import React from 'react'
import {connect} from "react-redux";
import {Col} from "react-bootstrap";
import Button from "antd/lib/button";
import Steps from "antd/lib/steps";
import Input from "antd/lib/input";
import message from "antd/lib/message";
import Loader from "../Loader"
import "antd/lib/steps/style/index.css";
import "antd/lib/button/style/index.css";
import "antd/lib/input/style/index.css";
import "antd/lib/message/style/index.css";
import {getLabel} from "../../language";
import VoterLocBlock from "../Utils/VoterLocation";
import SelectImagesBox from "../Utils/SelectImagesBox";
import TagsAutocomplete from "../TagsAutocomplete";
import {UPDATE_FIELD_EDITOR} from "../../constants/actionTypes";
import {fetchAudiences} from "../../actions/audiences";
import {addNewTag, clearTagsList, loadTagsSuggestions} from "../../actions/tags";
import agent from '../../agent'
import AudienceSelectionModal from "../Utils/AudienceSelectionModal";
import {APP_CONFIG} from "../../appconfig";

const defaultAvatar = APP_CONFIG.defaultAvatar;


const {Step} = Steps;
const {TextArea} = Input;

class Goals extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isEdit: false,
            audienceSelectionModal: false,
            current: 0,
            viewMyPostsAndComments: 2,
            replyMyPostsAndComments: 3,
            viewMyProfile: 0,
            title: '',
            goal: '',
            description: '',
            existingAddress: '',
            tagList: [],
            addressFields: [],
            selectedAudiencesIds: [],
            selectedAudiences: [],
            selectedAudiencesIdsForReply: [],
            object: {
                File: [],
                Id: '',
                Title: '',
                Description: '',
                Body: '',
                Tags: '',
                ViewMyPostsAndComments: '',
                ReplyMyPostsAndComments: '',
                ViewMyPostsAndCommentsDefault: '',
                ReplyMyPostsAndCommentsDefault: '',
                Status: 1,
                Sort: '',
                PersonID: '',
                LocationPlaceId: '',
                LocationStreet: '',
                LocationStreetNumber: '',
                LocationCountry: '',
                LocationProvince: '',
                LocationCounty: '',
                LocationCity: '',
                LocationPostcode: '',
                LocationLongitude: '',
                LocationLatitude: '',
                LocationInternationalBodyCode: '',
                ViewAudienceIds: '',
                ReplyAudienceIds: '',
            },
            status: 1,
            imageArray: null,
            response: {}
        }
    }

    getGoalFromUrlSlug = async() =>{
        if (this.props.match.params.slug !== "new") {
            await agent.Goals.getGoal(this.props.match.params.slug).then(res => {
                const {
                    title = "", goal = "", description = "", viewMyPostsAndComments = "", replyMyPostsAndComments = "", status = "",
                    locationPlaceId = "", locationStreet = "", locationStreetNumber = "", locationCountry = "", locationCountryCode = "", locationProvince = "", locationProvinceCode = "", locationCounty = "", locationCity = "", locationPostcode = "", locationLongitude = "", locationLatitude = "", locationInternationalBodyCode = ""
                } = (res || []).length && res[0] || {}

                let addressFields = []
                let existingAddress = ""
                if (locationPlaceId || locationStreet || locationStreetNumber || locationCountry || locationCountryCode || locationProvince || locationProvinceCode || locationCounty || locationCity || locationPostcode || locationLongitude || locationLatitude || locationInternationalBodyCode) {
                    addressFields.push({
                        country: locationCountry,
                        lat: locationLatitude,
                        lng: locationLongitude,
                        postal_code: locationPostcode,
                        street_number: locationStreetNumber,
                        place_id: locationPlaceId,
                        administrative_area_level_1: locationProvince,
                        administrative_area_level_2: locationCounty,
                        locality: locationCity,
                        route: locationStreet
                    })

                    let address = "";

                    if (locationStreetNumber || "")
                        address += (locationStreetNumber || "").replace("null", "");

                    if (locationStreet || "")
                        address += address ? ` ${(locationStreet || "").replace("null", "")}` : (locationStreet || "").replace("null", "")
                    address += address ? "," : ""

                    existingAddress = `${address || ""} ${(locationCity === "null" ? "" : locationCity) || ""}${(locationCity && locationCity !== "null" && locationProvinceCode && locationProvinceCode !== "null") ? ", " : ""}${(locationProvinceCode === "null" ? "" : locationProvinceCode) || ""}${(locationProvinceCode && locationProvinceCode !== "null" && locationCountry && locationCountry !== "null") ? ", " : ""}${locationCountry || ""}`
                }

                this.setState({
                    isEdit: true,
                    title,
                    goal,
                    description,
                    response: (res || []).length && res[0] || {},
                    viewMyPostsAndComments: viewMyPostsAndComments,
                    replyMyPostsAndComments: replyMyPostsAndComments,
                    addressFields,
                    existingAddress,
                    status: status,
                    addTagShow: !!(res[0].tags).length
                })

                const formattedTags = res[0].tags.map(tag => {
                    return {
                        id: tag && tag.id ? tag.id : null,
                        type: tag && tag.type ? tag.type : 'text',
                        text: tag && tag.name ? tag.name : tag,
                        photoName: tag && tag.photoName ? tag.photoName : null,
                        personID: tag && tag.personID ? tag.personID : null
                    }
                });
                this.props.addNewTag(formattedTags);
            }, err => {
                console.log({err})
                message.error('Something went wrong! Please try again later.')
            })
        }
        this.props.fetchAudiences();
    }

    async componentDidMount() {
        this.getGoalFromUrlSlug()
    }

    next = () => {
        const current = this.state.current + 1;
        this.setState({current});
    }

    prev = () => {
        const current = this.state.current - 1;
        this.setState({current});
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: parseInt(e.target.value),
        });
    }

    onPrivacyChange = (e) => {
        const state = this.state;
        state[e.target.name] = Number(e.target.value);
        if (parseInt(e.target.value) === 1) {
            state.audienceSelectionModal = true;
            state.privacyModal = false;
            if (e.target.name === 'viewMyPostsAndComments') {
                state.selectedAudienceForView = true;
            }
            if (e.target.name === 'replyMyPostsAndComments') {
                state.selectedAudienceForView = false;
                state.selectedAudiences = state.selectedAudiencesIds.length ? this.props.audiencesList.filter(x => state.selectedAudiencesIds.indexOf(x.id) >= 0) : (parseInt(state.viewMyPostsAndComments) !== 1) ? this.props.audiencesList : [];
                state.selectedAudiencesIdsForReply = state.selectedAudiencesIds.length ? state.selectedAudiencesIds.filter(x => state.selectedAudiencesIdsForReply.indexOf(x) >= 0) : state.selectedAudiencesIdsForReply;
            }
        } else {
            state.selectedAudiences = [];
            state.selectedAudiencesIds = [];
            state.selectedAudiencesIdsForReply = [];
        }

        if ((parseInt(state.viewMyPostsAndComments) === 1 || (parseInt(state.replyMyPostsAndComments) === 1)) && ((Array.isArray(state.selectedAudiencesIds) && state.selectedAudiencesIds.length === 0) || (Array.isArray(state.selectedAudiencesIdsForReply) && state.selectedAudiencesIdsForReply.length === 0))) {
            if ((parseInt(state.replyMyPostsAndComments) === 1) || (Array.isArray(state.selectedAudiencesIdsForReply) && state.selectedAudiencesIdsForReply.length === 0)) {
                state.errorMessage = {
                    message1: "Please Select Audiences.",
                    message2: "You don't have any audiences selected for your posts and comments: Who can see them. ",
                }
            }
        }
        this.setState(state);
    }

    onFirstStepChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    addPicAndImage = (e) => {
        this.setState({
            [e.target.id]: !this.state[e.target.id]
        })
    }

    changeTagsInput = (value) => {
        this.props.onUpdateField('tagInput', value);
        this.props.loadTagsSuggestions(value);
        this.setState({tag: value})
    }

    onSelectImages = (data) => {
        const {response} = this.state
        let formData = new FormData();
        data.forEach((img) => {
            let blobBin = atob(img.preview.split(',')[1]);
            let array = [];
            for (let i = 0; i < blobBin.length; i++) {
                array.push(blobBin.charCodeAt(i));
            }
            let file = new Blob([new Uint8Array(array)], {type: 'image/png'});
            formData.append(img.file.name, file)
            if ((response || {}).id) {
                formData.append("GoalId", response.id)
            }
        })

        this.setState({imageArray: formData});
        this.props.onUpdateField('images', data)
    }

    newFormData = (data) => {
        this.setState({imageArray: data})
    }

    setTags = (newTags) => {
        const formattedTags = newTags.map(tag => {
            let isMatched;
            const {tags} = this.props.tags;

            if (!this.props.tags.hasError) {
                isMatched = this.props.tags.suggestions.find(item => item.displayName === tag);
            }

            if (!isMatched) {
                isMatched = tags.find(item => item.text === tag);
            }

            return {
                id: isMatched && isMatched.id ? isMatched.id : null,
                type: isMatched && isMatched.type ? isMatched.type : 'text',
                text: isMatched && isMatched.name ? isMatched.name : tag,
                photoName: isMatched && isMatched.photoName ? isMatched.photoName : null,
                personID: isMatched && isMatched.personID ? isMatched.personID : null
            }
        });
        this.props.addNewTag(formattedTags);
    }

    firstStep = () => {
        const {title, goal, description, isEdit} = this.state
        return (
            <div>
                <div>
                    <div>Title</div>
                    <small>Enter Title</small>
                    <input
                        type="text"
                        className={`form-control${this.props.anonymousMode ? "-dark" : ""} form-control-lg`}
                        placeholder="Title"
                        value={title || ''}
                        name="title"
                        onChange={this.onFirstStepChange}
                        maxLength={100}
                        disabled={isEdit}
                    />
                </div>
                <div className="m-t-10">
                    <div>Goal</div>
                    <small>Enter Goal</small>
                    <TextArea
                        className={`form-control${this.props.anonymousMode ? "-dark cw" : "goal-border"} form-control-lg`}
                        placeholder="Goal"
                        maxLength={200}
                        name="goal"
                        value={goal}
                        onChange={this.onFirstStepChange}
                        style={{
                            background: `${this.props.anonymousMode ? "#1d1f20" : ""}`,
                            fontSize: "inherit",
                            fontFamily: "inherit"
                        }}
                    />
                </div>
                <div className="m-t-10">
                    <div>Description</div>
                    <small>Enter Description</small>
                    <TextArea
                        className={`form-control${this.props.anonymousMode ? "-dark cw" : "goal-border"} form-control-lg`}
                        placeholder="Description"
                        name="description"
                        value={description || ''}
                        onChange={this.onFirstStepChange}
                        style={{
                            height: "202px",
                            background: `${this.props.anonymousMode ? "#1d1f20" : ""}`,
                            fontSize: "inherit",
                            fontFamily: "inherit"
                        }}
                    />
                    {/*<input*/}
                    {/*    type="text"*/}
                    {/*    className={`form-control${this.props.anonymousMode ? "-dark" : ""} form-control-lg`}*/}
                    {/*    placeholder="Description"*/}
                    {/*    value={description || ''}*/}
                    {/*    name="description"*/}
                    {/*    onChange={this.onFirstStepChange}*/}
                    {/*/>*/}
                </div>
                {
                    !isEdit ?
                        <Button
                            className={`btn m-t-10 smallmargintop text-whitewaves-effect waves-light btn-primary${this.props.anonymousMode ? "-dark" : ""}`}
                            type="primary" onClick={() => this.next()} disabled={!title || !goal || !description}>
                            Next
                        </Button> : null
                }
            </div>
        )
    }

    onLocationSelect = (array) => {
        this.setState({
            addressFields: array
        })
    }

    secondStep = () => {
        const {isEdit, addressFields, existingAddress} = this.state
        const {anonymousMode} = this.props
        return (
            <div>
                <div className="m-t-20">
                    <small>{!!existingAddress ? "" : "Enter"} Location</small>
                    {
                        !!existingAddress && isEdit ?
                            <div>{existingAddress} <span className="color-link cursor-pointer m-l-10"
                                                         onClick={() => this.setState({existingAddress: ""})}>Change Location</span>
                            </div> :
                            <VoterLocBlock
                                onVoterLocationAdded={this.props.onVoterLocationAdded}
                                currentUser={this.props.currentUser}
                                fetchUser={this.props.fetchUser}
                                multiForms={false}
                                onLocationSelect={this.onLocationSelect}
                                fillLocation={true}
                                addressFields={addressFields || []}
                                isGoal
                            />
                    }

                </div>
                {
                    !isEdit ?
                        <>
                            <Button type={`${anonymousMode ? "primary" : ""}`} className="m-t-10"
                                    style={{marginRight: 8}}
                                    onClick={() => this.prev()}>
                                Previous
                            </Button>
                            <Button type="primary" onClick={() => this.next()}>
                                Next
                            </Button>
                        </> : null
                }
            </div>
        )
    }

    thirdStep = (isEditing) => {
        const {isEdit} = this.state
        const {anonymousMode} = this.props
        const isAudiencesList = !((this.props.audiencesList || []).length > 0);
        return (
            <div>
                <div>
                    <div className="row">
                        <div className={`col-md-${isEditing ? "12" : "6"}`}>
                            <legend className={`${this.props.anonymousMode ? "cw" : ""}`}>{getLabel(260)}</legend>
                            <fieldset className={`form-group privacy-list ${this.props.anonymousMode ? "bgl" : ""}`}>
                                <div className="form-check">
                                    <input type="radio" className="form-check-input" onChange={this.onPrivacyChange}
                                           onClick={this.onPrivacyChange} disabled={isAudiencesList || false}
                                           name="viewMyPostsAndComments" id="viewMyPostsAndComments1" value={1}
                                           checked={this.state.viewMyPostsAndComments === 1}/>
                                    <label className="form-check-label"
                                           htmlFor="viewMyPostsAndComments1">{getLabel(71)}</label>
                                </div>
                                <div className="form-check">
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        onChange={this.onPrivacyChange}
                                        name="viewMyPostsAndComments"
                                        id="viewMyPostsAndComments2"
                                        value={2}
                                        checked={this.state.viewMyPostsAndComments === 2}
                                    />
                                    <label className="form-check-label"
                                           htmlFor="viewMyPostsAndComments2">{getLabel(72)}</label>
                                </div>
                                <div className="form-check">
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        onChange={this.onPrivacyChange}
                                        name="viewMyPostsAndComments"
                                        id="viewMyPostsAndComments3"
                                        value={3}
                                        checked={this.state.viewMyPostsAndComments === 3}
                                    />
                                    <label className="form-check-label"
                                           htmlFor="viewMyPostsAndComments3">{getLabel(73)}</label>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <div className="row">
                        <div className={`col-md-${isEditing ? "12" : "6"}`}>
                            <legend className={`${this.props.anonymousMode ? "cw" : ""}`}>{getLabel(261)}</legend>
                            <fieldset className={`form-group privacy-list ${this.props.anonymousMode ? "bgl" : ""}`}>
                                <div className="form-check">
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        id="replyMyPostsAndComments1"
                                        onChange={this.onPrivacyChange}
                                        name="replyMyPostsAndComments" value={1}
                                        checked={this.state.replyMyPostsAndComments === 1}
                                    />
                                    <label className="form-check-label"
                                           htmlFor="replyMyPostsAndComments1">{getLabel(71)}</label>
                                </div>
                                <div className="form-check">
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        onChange={this.onPrivacyChange}
                                        name="replyMyPostsAndComments"
                                        id="replyMyPostsAndComments2"
                                        value={2}
                                        checked={this.state.replyMyPostsAndComments === 2}
                                    />
                                    <label className="form-check-label"
                                           htmlFor="replyMyPostsAndComments2">{getLabel(72)}</label>
                                </div>
                                <div className="form-check">
                                    <input
                                        type="radio"
                                        className="form-check-input"
                                        onChange={this.onPrivacyChange}
                                        name="replyMyPostsAndComments"
                                        id="replyMyPostsAndComments3"
                                        value={3}
                                        checked={this.state.replyMyPostsAndComments === 3}
                                    />
                                    <label className="form-check-label"
                                           htmlFor="replyMyPostsAndComments3">{getLabel(73)}</label>
                                </div>
                            </fieldset>
                        </div>
                    </div>

                </div>
                <div className="mb-80">
                    {
                        !isEdit ?
                            <>
                                <Button type={`${anonymousMode ? "primary" : ""}`} style={{marginRight: 8}}
                                        onClick={() => this.prev()}>
                                    Previous
                                </Button>
                                <Button type="primary" onClick={() => this.next()}>
                                    Next
                                </Button>
                            </> : null
                    }
                </div>
            </div>

        )
    }

    fourthStep = () => {
        const {suggestions, tags} = this.props.tags;
        const {isSaving, isEdit} = this.state;
        const {anonymousMode} = this.props

        return (
            <div>
                <div id="moodtoolbar">
                    <a className={`btn btn-default ${anonymousMode ? "btn-primary-dark" : "btn-mini"} addtagslink smallmargintop m-r-15`}
                       id="addTagShow" onClick={this.addPicAndImage}>
                        {/*<i className="icon-tag pol" id="addTagShow" />*/} Add Tags
                    </a>

                    <a className={`btn btn-default ${anonymousMode ? "btn-primary-dark" : "btn-mini"} smallmargintop m-r-15 `}
                       id="addImageShow" onClick={this.addPicAndImage}>
                        {/*<i className="icon-pic pol" id="addImageShow" />*/} Add Picture
                    </a>
                </div>
                {this.state.addImageShow &&
                <fieldset className={`form-group ${this.props.anonymousMode ? "dark" : ""}`}>
                    <SelectImagesBox onSelectImages={this.onSelectImages} newFormData={this.newFormData}
                                     defaultAvatar={defaultAvatar}/>
                </fieldset>
                }
                {
                    this.state.addTagShow &&
                    <div className="addtagsdiv hidden">
                        <div className={`bootstrap-tagsinput${this.props.anonymousMode ? "-dark dark" : ""}`}>
                            <TagsAutocomplete
                                onChangeInput={this.changeTagsInput}
                                suggestions={suggestions}
                                setTags={this.setTags}
                                formatedTags={tags || this.state.response.tags}
                            />
                        </div>
                        <input type="text" value={this.props.tagList || []}
                               className={`form-control${this.props.anonymousMode ? "-dark" : ""}`}
                               data-role="tagsinput" placeholder={getLabel(54)} style={{display: 'none'}}/>
                    </div>
                }
                {
                    isEdit && !!(this.state.response.images).length &&
                    <div className='row mt-2'>
                        <div className='col-md-8 col-sm-12'>
                            <div className='row'>
                                <div className='col-md-5 col-sm-6'>
                                    <h6>Source image:</h6>
                                </div>
                                <div className='col-md-3 col-sm-6'>
                                    <div style={{height: '130px', width: '130px'}}>
                                        {(this.state.response.images).length &&
                                        this.state.response.images && this.state.response.images.map((img) => {
                                            return (<img src={`data:${img.contentType};base64,${img.base64String}`}
                                                         style={{opacity: 1, height: '100%', width: '100%'}}
                                                         className="politicians-vote-img width-unset border-radius-10"
                                                         alt=""/>)
                                        })
                                        }
                                    </div>
                                    {
                                        <button className="btn btn-md btn-danger mx-auto mt-2" type="button"
                                                onClick={this.onDeleteImageGoal}>{getLabel(131)}</button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    !isEdit ?
                        <>
                            <Button type={`${anonymousMode ? "primary" : ""}`} className="m-t-10"
                                    style={{marginRight: 8}}
                                    onClick={() => this.prev()}>
                                Previous
                            </Button>
                            <Button type="primary" onClick={this.onSubmit} loading={isSaving}>
                                Submit
                            </Button>
                        </> : null
                }
            </div>
        )
    }

    onSubmit = async () => {
        const {title, goal, description, addressFields, viewMyPostsAndComments, replyMyPostsAndComments, selectedAudiencesIdsForReply, selectedAudiencesIds, imageArray, status} = this.state
        const {country, lat, lng, postal_code, street_number, place_id, administrative_area_level_1, administrative_area_level_2, locality, route} = (addressFields || []).length && addressFields[0] || {}
        const tags = this.props.tags.tags;
        const formatedTags = tags.map(tag => {
            return {
                id: tag.id,
                name: tag.text,
                type: tag.type
            }
        })

        if ((parseInt(viewMyPostsAndComments) === 1 || (parseInt(replyMyPostsAndComments) === 1)) && ((Array.isArray(selectedAudiencesIds) && selectedAudiencesIds.length === 0) || (Array.isArray(selectedAudiencesIdsForReply) && selectedAudiencesIdsForReply.length === 0))) {
            if ((parseInt(replyMyPostsAndComments) === 1) || (Array.isArray(selectedAudiencesIdsForReply) && selectedAudiencesIdsForReply.length === 0)) {
                this.setState({
                    errorMessage: {
                        message1: "Please Select Audiences.",
                        message2: "You don't have any audiences selected for your posts and comments: Who can see them. ",
                    },
                    privacyModal: !this.state.privacyModal
                });
                return
            }
            this.setState({
                audienceSelectionModal: true,
                selectedAudienceForView: true
            });
            return
        }

        let data = {}
        data.Title = title || ''
        data.Body = goal || ''
        data.Description = description || ''
        data.Tags = formatedTags || []
        data.File = []
        data.ViewMyPostsAndComments = viewMyPostsAndComments || ''
        data.ReplyMyPostsAndComments = replyMyPostsAndComments || ''
        data.ViewMyPostsAndCommentsDefault = viewMyPostsAndComments || ''
        data.ReplyMyPostsAndCommentsDefault = replyMyPostsAndComments || ''
        data.Status = status || ''
        data.Sort = ""
        data.PersonID = ""
        data.LocationPlaceId = place_id || ''
        data.LocationStreet = route || ''
        data.LocationStreetNumber = street_number || ''
        data.LocationCountry = country || ''
        data.LocationProvince = administrative_area_level_1 || ''
        data.LocationCounty = administrative_area_level_2 || ''
        data.LocationCity = locality || ''
        data.LocationPostcode = postal_code || ''
        data.LocationLongitude = lng || ''
        data.LocationLatitude = lat || ''
        data.LocationInternationalBodyCode = ""
        data.ViewAudienceIds = selectedAudiencesIds || ''
        data.ReplyAudienceIds = selectedAudiencesIdsForReply || ''

        if (imageArray) {
            // agent.Goals.goalImageUpload(imageArray).then(async res => {
            //     formData.append("File", JSON.stringify(res.body || []));
            //     this.onSaveGoal(formData)
            // })
            if (this.state.isEdit) {
                agent.Goals.updateGoal(data, this.state.response.id).then(async res => {
                    await this.onGoalImageUpload(imageArray, res.goalId)
                })
            } else {
                agent.Goals.createGoalWithFormData(data).then(async res => {
                    await this.onGoalImageUpload(imageArray, res.goalId)
                })
            }
        } else {
            this.onSaveGoal(data)
        }
    }

    onGoalImageUpload = async (imageArrays, GoalId) => {
        const {response: {urlslug = "", id = ""} = {}} = this.state
        imageArrays.append("GoalId", GoalId)
        agent.Goals.goalImageUpload(imageArrays).then(async res => {
            message.success(id ? "Updated Successfully" : "Thank you/Completed")
            setTimeout(() => this.props.history.push(id ? `/goals/${urlslug}` : "/goals/thanks"), 1000)
        })
    }

    onDeleteImageGoal = async () => {
        if (window.confirm('Are you sure you want to delete this profile picture?')) {
            await agent.Goals.deleteGoalImage(this.state.response.id)
            this.getGoalFromUrlSlug()
        }
    }

    onSaveGoal = async (formData) => {
        const {response: {urlslug = "", id = ""} = {}} = this.state
        const url = id ? agent.Goals.updateGoal : agent.Goals.createGoalWithFormData
        await url(formData, id).then(res => {
            message.success(id ? "Updated Successfully" : "Thank you/Completed")
            setTimeout(() => this.props.history.push(id ? `/goals/${urlslug}` : "/goals/thanks"), 1000)
        }, err => {
            console.log({err})
            message.error('Something went wrong! Please try again later.')
        })
    }

    audienceSelectionModal = () => {
        this.setState({
            audienceSelectionModal: !this.state.audienceSelectionModal
        })
    };

    render() {
        const {isLoading, current, isEdit, isSaving, audienceSelectionModal, selectedAudienceForView, selectedAudiences} = this.state
        const isAudiencesList = !(this.props.audiencesList && this.props.audiencesList.length > 0);
        if (isLoading) {
            return <Loader/>
        }
        return (
            <div className="row admin-setting p-b-90">
                {
                    audienceSelectionModal &&
                    <AudienceSelectionModal
                        onChange={this.onChecked}
                        audienceSelectionModal={this.audienceSelectionModal}
                        state={this.state}
                        isAudiencesList={isAudiencesList}
                        audiencesList={selectedAudienceForView ? this.props.audiencesList : selectedAudiences}
                    />
                }
                <Col sm={12}>

                    <div className={`tab-content ${this.props.anonymousMode ? "cw" : ""}`} style={{marginTop: '20px'}}>
                        <div className={"tab-pane active"}>
                            <div className="row">
                                <Col sm={12}>
                                    {
                                        isEdit ?
                                            <div className="row">
                                                <div className="col-md-8 col-8 col-xs-12 col-12">
                                                    <div
                                                        className={`politicians-row${this.props.anonymousMode ? "-dark" : ""}`}>
                                                        {this.firstStep()}
                                                    </div>
                                                    <div
                                                        className={`politicians-row${this.props.anonymousMode ? "-dark" : ""}`}>
                                                        {this.secondStep()}
                                                    </div>
                                                    {/*<div className="politicians-row">
                                                        {this.thirdStep()}
                                                    </div>*/}
                                                    <div
                                                        className={`politicians-row${this.props.anonymousMode ? "-dark" : ""}`}>
                                                        {this.fourthStep()}
                                                    </div>
                                                    <div>
                                                        <Button type="primary" onClick={this.onSubmit}
                                                                loading={isSaving}>
                                                            Update
                                                        </Button>
                                                    </div>
                                                </div>

                                                <div className="col-md-4 col-xs-12 col-12">
                                                    <div
                                                        className={`${this.props.anonymousMode ? "bgm" : "greybg"} postsettings`}>
                                                        {this.thirdStep(true)}
                                                    </div>
                                                </div>

                                            </div> :
                                            <div
                                                className={`politicians-row${this.props.anonymousMode ? "-dark dark" : ""}`}>
                                                <Steps size="small" current={current}>
                                                    <Step title={getLabel(263)}/>
                                                    <Step title={getLabel(264)}/>
                                                    <Step title={getLabel(265)}/>
                                                    <Step title={getLabel(266)}/>
                                                </Steps>
                                                <div className="m-t-20">
                                                    {current === 0 && this.firstStep()}
                                                    {current === 1 && this.secondStep()}
                                                    {current === 2 && this.thirdStep(false)}
                                                    {current === 3 && this.fourthStep()}
                                                </div>
                                            </div>
                                    }
                                </Col>
                            </div>
                        </div>
                    </div>
                </Col>
            </div>
        )
    }

}

const mapStateToProps = state => ({
    ...state.editor,
    quickPost: state.quickPost,
    currentUser: state.common.currentUser,
    tags: state.tags,
    audiencesList: state.audiencesList.audiencesList || [],
    isUserLoaded: state.common.userLoaded,
    anonymousMode: state.user.anonymousMode
});

const mapDispatchToProps = dispatch => ({
    onUpdateField: (key, value) =>
        dispatch({type: UPDATE_FIELD_EDITOR, key, value}),
    fetchAudiences: dispatch(fetchAudiences),
    loadTagsSuggestions: dispatch(loadTagsSuggestions),
    clearTagsList: dispatch(clearTagsList),
    addNewTag: dispatch(addNewTag)
});

export default connect(mapStateToProps, mapDispatchToProps)(Goals);
